import { Component } from '@angular/core';

@Component({
  selector: 'lib-unauthorized-admin',
  imports: [],
  templateUrl: './unauthorized-admin.html',
  styleUrl: './unauthorized-admin.scss',
})
export class UnauthorizedAdmin {}
